module.exports = __webpack_public_path__ + "static/media/a.91534cef.jpg";